<template>
    <div id="console-overlay"
         :style="isDebugMode">
        <div class="console-overlay-content">
             <div id="console-header" class="console-header">
                <div class="console-header-title">
                    <span>Console</span>
                </div>
                <div class="console-header-close" @click="closeConsole()">
                    <span>X</span>
                </div>
            </div>
            <div id="console-body" class="console-body">
                <div class="console-body-content">
                    <console-settings></console-settings>
                    <console-runtime
                        :current-time-player="currentTimePlayer"></console-runtime>
                    <console-time></console-time>
                </div>
                <div class="console-body-content">
                    <console-hotspot></console-hotspot>
                </div>
                <div class="console-body-content">
                    <console-log></console-log>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import ConsoleSettings from "@/playerVue3/components/console/console-settings.vue";
import ConsoleRuntime from "@/playerVue3/components/console/console-runtime.vue";
import ConsoleHotspot from "@/playerVue3/components/console/console-hotspot.vue";
import ConsoleTime from "@/playerVue3/components/console/console-time.vue";
import ConsoleLog from "@/playerVue3/components/console/console-log.vue";

// INITIALIZE STORE & COMPOSABLES

// PROPS
const props = defineProps({
    currentTimePlayer: {
        type: Number,
        default: 0,
    },
});

// REACTIVE VARIABLES
const isDebugMode = computed(() => {
    if ($('#videoPlayerContainer').data('debug') != undefined && $('#videoPlayerContainer').data('debug') == true) {
        return "display: block;";
    }

    return "display: none;";
});

// COMPUTED PROPERTIES

// METHODS
const closeConsole = () => {
    $('#console-overlay').css('display', 'none');
    $('#checkbox-console-video').prop('checked', false);
};

// LIFECYCLE HOOKS
</script>
